import { lifecycle } from 'recompose';
import { GlobalStates } from '../../states/globalStates';
import { routingStore } from '../../../common/stores/routing';
import { V2Routes } from '../../routes';

/**
 * Redirects users to sign in page when she is not signed in
 */
export const authenticated = lifecycle({
  componentDidMount() {
    if (!GlobalStates.currentUser.isSignedIn()) {
      routingStore.push(V2Routes.signInPage(location.href));
    }
  },
});
